<template>
  <div class="tariffs">

    <Tariff @click="$refs.inputs[i].$el.click()" v-for="t,i in tariffs" :tariff="t" :key="t.name" :class="{'active': form.tariff == t.name}">
      <RadioInput ref="inputs" :key="t.name" v-model="form.tariff" name="tariff" :inputvalue="t.name" :required="true"/>
    </Tariff>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RadioInput from './RadioInput.vue';
import Tariff from './Tariff.vue';
export default {
  components: { Tariff, RadioInput },
  computed: {
    ...mapState(['tariffs', 'form'])
  }
}
</script>

<style lang="sass">
.tariffs
  display: flex
  justify-content: center
  align-items: center
  .tariff:not(:last-child)
    margin-right: 32px
  @include from(650px)
    flex-direction: column
    .tariff:not(:last-child)
      margin-right: 0px
      margin-bottom: 16px

</style>